import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ReviewBoardListItem,
  ReviewBoardStatusResponse,
} from '@models/review-board.model';

export const ReviewBoardActions = createActionGroup({
  source: 'Review Board',
  events: {
    'Load List': emptyProps(),
    'Load List Success': props<{ items: ReviewBoardListItem[] }>(),
    'Load List Failure': props<{ error: string }>(),

    'Load Status': props<{ submissionId: number }>(),
    'Load Status Success': props<{ status: ReviewBoardStatusResponse }>(),
    'Load Status Failure': props<{ error: string }>(),

    'Request Review': props<{ submissionId: number }>(),
    'Request Review Success': props<{ status: ReviewBoardStatusResponse }>(),
    'Request Review Failure': props<{ error: string; submissionId: number; isConflict: boolean }>(),

    'Cancel Review': props<{ submissionId: number }>(),
    'Cancel Review Success': props<{ status: ReviewBoardStatusResponse }>(),
    'Cancel Review Failure': props<{ error: string; submissionId: number; isConflict: boolean }>(),
  },
});
